import dayjs from "dayjs";

export const getDateRange = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { months: [], days: [] };
  }

  let earliest = dayjs(data[0].routingStart).startOf("day");
  let latest = dayjs(data[0].routingEnd).endOf("day");

  for (const item of data) {
    const start = dayjs(item.routingStart).startOf("day");
    const end = dayjs(item.routingEnd).endOf("day");
    if (start < earliest) earliest = start;
    if (end > latest) latest = end;
  }

  const days = [];
  const months = [];
  let current = earliest;
  let currentMonth = current.format("MMMM YYYY");
  let monthSpan = 0;

  while (current <= latest) {
    // Push day info
    days.push({
      id: current.format("MM-DD-YYYY"),
      label: current.format("D,ddd"), // e.g. "17 Mon"
    });

    // Count days in this month
    const monthLabel = current.format("MMMM YYYY");
    if (monthLabel === currentMonth) {
      monthSpan++;
    } else {
      // Push previous month summary
      months.push({
        label: currentMonth,
        span: monthSpan,
      });
      // Start counting for new month
      currentMonth = monthLabel;
      monthSpan = 1;
    }

    current = current.add(1, "day");
  }

  // Push final month summary
  months.push({
    label: currentMonth,
    span: monthSpan,
  });

  return { months, days };
};

const pinnedWidth = 330;
const padding = 12;
export const handleScroll = (e) => {
  const scrollLeft = e.target.scrollLeft;
  if (!scrollLeft) return;

  const headers = document.querySelectorAll(".schedule-month-cell");

  headers?.forEach((th) => {
    const rect = th.getBoundingClientRect();

    const { innerWidth } = window;
    const isOut =
      innerWidth < rect.x || (rect.x < 0 && rect.width + rect.x <= 0);
    const isBehindBarAndVisible =
      rect.x < pinnedWidth && rect.width - rect.x > pinnedWidth;

    const push = !isOut && isBehindBarAndVisible;

    const text = th.children[0];

    if (!push) {
      text.style.position = "absolute";
      text.style.left = "12px";
      text.style.right = "auto";
      text.style.top = "0px";
      text.style.margin = "auto";
      return;
    }

    const textWidth = text.offsetWidth;
    const move = pinnedWidth - rect.x + padding;
    const remaining = rect.width - padding - move - textWidth;

    const isFixed = text.style.position === "fixed";

    if (remaining <= 5) {
      text.style.position = "absolute";
      text.style.right = "12px";
      text.style.left = "auto";
      text.style.top = "0px";
      text.style.margin = "auto";
      return;
    }

    if (isFixed) return;

    text.style.position = "fixed";
    text.style.left = `342px`;
    text.style.right = "auto";
    text.style.top = `101px`;
    text.style.margin = "0px";
  });
};
